module.exports = __webpack_public_path__ + "img/logo-517.faf8402.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo-517.png
// module id = 1157
// module chunks = 265